import React from "react";
import { SiMaildotru, SiGooglemaps } from "react-icons/si";

const Contact = () => {
  return (
    <section className="bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 py-16">
      <div className="container mx-auto px-4">
        {/* Page Header */}
        <h1 className="text-4xl font-bold text-center mb-10 text-brandcolour">
          Get in Touch
        </h1>
        <p className="text-center text-lg mb-10">
          We'd love to hear from you! Reach out with any questions, feedback, or
          inquiries.
        </p>

        {/* Contact Form and Info */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          {/* Contact Information */}
          <div className="space-y-6">
            <div className="flex items-center space-x-4">
              <div className="text-brandcolour text-3xl">
                <SiMaildotru />
              </div>
              <div>
                <h3 className="text-xl font-semibold">Email</h3>
                <p>
                  <a
                    href="mailto:enquires@hazeitsolutions.com"
                    className="text-brandcolour hover:underline"
                  >
                    enquires@hazeitsolutions.com
                  </a>
                </p>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <div className="text-brandcolour text-3xl">
                <SiGooglemaps />
              </div>
              <div>
                <h3 className="text-xl font-semibold">Location</h3>
                <p>Sutton In Ashfield, Notthinghamshire</p>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <form
            className="bg-gray-100 dark:bg-gray-800 p-8 rounded-lg shadow-lg space-y-6"
            action="https://formspree.io/f/mnnnkvqn" //Formspree endpoint
            method="POST"
          >
            <h2 className="text-2xl font-semibold text-center mb-4">
              Send Us a Message
            </h2>
            <div>
              <label
                htmlFor="name"
                className="block text-lg font-semibold mb-2"
              >
                Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                placeholder="Your Name"
                required
                className="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 focus:ring-2 focus:ring-brandcolour"
              />
            </div>

            <div>
              <label
                htmlFor="email"
                className="block text-lg font-semibold mb-2"
              >
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Your Email"
                required
                className="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 focus:ring-2 focus:ring-brandcolour"
              />
            </div>

            <div>
              <label
                htmlFor="message"
                className="block text-lg font-semibold mb-2"
              >
                Message
              </label>
              <textarea
                id="message"
                name="message"
                rows="5"
                placeholder="Your Message"
                required
                className="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-900 focus:ring-2 focus:ring-brandcolour"
              ></textarea>
            </div>

            <button
              type="submit"
              className="w-full bg-brandcolour text-white font-semibold py-3 rounded-lg hover:bg-purple-700 transition"
            >
              Send Message
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
